import { Box, Group, Stack, Text } from "@mantine/core";
import { DonutChart } from "@mantine/charts";
import "@mantine/charts/styles.css";
import { DONUT_SEGMENT_COLORS, getStaticSectorCompanyStats } from "../sectorEcosystem.const";
import SectorDashboardCard from "./SectorDashboardCard";

type SectorCompaniesDonutCardProps = {
  slug: string;
};

export default function SectorCompaniesDonutCard({ slug }: SectorCompaniesDonutCardProps) {
  const { segments, totalLabel } = getStaticSectorCompanyStats(slug);
  const chartData = segments.map((segment, index) => ({
    name: segment.label,
    value: segment.count,
    color: DONUT_SEGMENT_COLORS[index % DONUT_SEGMENT_COLORS.length],
  }));

  return (
    <SectorDashboardCard
      title="Companies"
    >
      <Stack gap="sm" align="center">
        <Box w="100%" maw={140}>
          <DonutChart
            data={chartData}
            chartLabel={totalLabel}
            withLabelsLine={false}
            withTooltip
            tooltipDataSource="segment"
            size={120}
            thickness={18}
            valueFormatter={(value) => `${value}+`}
            styles={{
              label: {
                fontSize: 18,
                fontWeight: 700,
                fill: "#0F172A",
              },
            }}
          />
        </Box>
        <Stack gap={6} w="100%">
          {segments.map((segment, index) => (
            <Group key={segment.key} justify="space-between" wrap="nowrap">
              <Group gap={6} wrap="nowrap">
                <Box
                  w={8}
                  h={8}
                  style={{
                    borderRadius: 999,
                    backgroundColor: DONUT_SEGMENT_COLORS[index % DONUT_SEGMENT_COLORS.length],
                  }}
                />
                <Text size="xs" c="#334155">
                  {segment.label}
                </Text>
              </Group>
              <Text size="xs" fw={600}>
                {segment.percent}%
              </Text>
            </Group>
          ))}
        </Stack>
      </Stack>
    </SectorDashboardCard>
  );
}
